import React from 'react';
import { showTopLevelNavigation } from 'global-config';
import { v as bvVar } from 'bv';
import TabsMenuView from './tabs_menu_view';

export default () => (
  showTopLevelNavigation && <TabsMenuView tabs={bvVar('topNavSections')} />
);
